import { RootState } from "@store";

export const selectManager = (state: RootState) => {
  return state.manager.manager;
};
